import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  async loadRequesterParties () {
    return new Promise((resolve, reject) => {
      axiosInstance.get('/atp/mock/party/').then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async getRequesterPartyDetail (partyId) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/atp/mock/party/${partyId}/`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async createRequesterParty (gln) {
    return new Promise((resolve, reject) => {
      const formData = { gln }

      axiosInstance.post('/atp/mock/party/', formData, { headers: { 'Content-Type': 'application/json' } }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async updateRequesterParty (gtins = [], partyId) {
    return new Promise((resolve, reject) => {
      const formData = { gtins: gtins }

      axiosInstance.patch(`/atp/mock/party/${partyId}/`, formData, { headers: { 'Content-Type': 'application/json' } }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}
